// extracted by mini-css-extract-plugin
module.exports = {"mixAndMatchGallery":"styles_mixAndMatchGallery__TojsB","mixAndMatchGallery__Carousel":"styles_mixAndMatchGallery__Carousel__BJil3"};